<template>
  <ServiceItem
    v-if="start"
    :title="'Bachata'"
    :status="status"
    :channel-slug="channelSlug"
    :icon="require('../../../assets/images/bachata-icon.svg')"
    :web-hook-url="webHookUrl"
    page-name-to-add="channels_bachata_add"
    page-name-to-edit="channels_bachata_edit"
    @delete="handleDelete"
  />
</template>

<script>
import Bachata from '../../../api/http/models/bachata/Bachata'
import ServiceItem from './ServiceItem'
import { mapGetters } from 'vuex'

export default  {
  props: {
    channelSlug: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      start: false,
      status: '',
      webHookUrl: ''
    }
  },

  components: {
    ServiceItem
  },

  computed: {
    ...mapGetters(['authUserCompany'])
  },

  async created () {
    const response = await Bachata.get(this.authUserCompany.slug, this.channelSlug)

    if (response.data) {
      this.status = response.data.status
      this.webHookUrl = response.data.webhook_url ||  ''
    } else {
      this.status = 'ready_to_add'
    }

    this.start = true
  },

  methods: {
    async handleDelete () {
      const response = await Bachata.delete(this.authUserCompany.slug, this.channelSlug)

      if (response.status === 'success') {
        this.$vs.notify({
          color: 'success',
          title: 'Мессенджер успешно удален',
          text: ''
        })
        this.status = 'ready_to_add'
      }
    }
  }
}
</script>
